/* Component Dependencies */
var hfsHotelDetailsTemplate = require('templates/hfsHotelDetails.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Constants = require('libs/constants');

AriesComponent.create({
  type: 'hfsHotelDetails',
  template: {
    'hfsHotelDetails': hfsHotelDetailsTemplate
  },

  subscribe: {
    'HFS_ACCORDION_EXPANDED': 'accordionHandler',
    "HOTELFACTSHEET_REFRESH": 'refresh'
  },

  events: {
    'click .js-button-container': 'accordionToggleButtonHandler'
  },

  bindEvents: function () {
    var _self = this;
    _self.totalCount = parseInt(_self.$el.find('.js-accordian-count').val());
    _self.accordionLocalCount = 0,
    _self.$document = $(document);

    _self.$document
    .off('keydown.hotel-fact-sheet')
    .on('keydown.hotel-fact-sheet', function (event) {
      _self.hotKeysHandler(event);
    });
  },

  hotKeysHandler : function _hotKeysHandler(event) {
    var _self = this, 
    keyValue = event.which || event.keyCode,
      expandCollapseKeyCode = this.$el.find('.js-button-container').data('expandCollapseKeyCode');
			
    if(event.altKey && keyValue) {
      if (keyValue === expandCollapseKeyCode) {
        _self.$el.find('.js-button-container button').not('.is-hidden').trigger('click');
      } else {
        this.pubsub.publish('HFS_OPEN_BY_HOTKEY', [keyValue]);
      }
      event.stopPropagation();
      event.preventDefault();
    }
    return true;
  },
	
  accordionHandler: function _accordionHandler (requestType) {
    var _self = this;
    var expandButton = _self.$el.find('.js-expand-button');
    var collapseButton = _self.$el.find('.js-collapse-button');

    if (requestType === Constants.HOTEL_FACT_SHEET_ACCORDION_EVENT.ACTION_TYPE.EXPAND) {
      _self.accordionLocalCount++;
    } else if (requestType === Constants.HOTEL_FACT_SHEET_ACCORDION_EVENT.ACTION_TYPE.COLLAPSE) {
      _self.accordionLocalCount--;
    }

    if(_self.accordionLocalCount === _self.totalCount) {
      expandButton.addClass('is-hidden');
      collapseButton.removeClass('is-hidden');
    } else {
      expandButton.removeClass('is-hidden');
      collapseButton.addClass('is-hidden');
    }
  },

  accordionToggleButtonHandler: function _accordionToggleButtonHandler (event) {
    var _self = this;
    var $target = $(event.currentTarget);
    var expandButton = _self.$el.find('.js-expand-button');
    var collapseButton = _self.$el.find('.js-collapse-button');


    if($target.find('button:visible').hasClass('js-expand-button')) {
      _self.accordionLocalCount = _self.totalCount;
      this.pubsub.publish('HFS_ACCORDION_CLICK', [Constants.HOTEL_FACT_SHEET_ACCORDION_EVENT.ACTION_TYPE.EXPAND_ALL]);
    } else {
      _self.accordionLocalCount = 0;
      this.pubsub.publish('HFS_ACCORDION_CLICK', [Constants.HOTEL_FACT_SHEET_ACCORDION_EVENT.ACTION_TYPE.COLLAPSE_ALL]);
    }
    $target.find('button').toggleClass('is-hidden');
    $target.find('button:visible').focus();
  }

});
